// extracted by mini-css-extract-plugin
module.exports = {"cards":"collections_cards__8Epor"};